/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { observer } from "mobx-react-lite"
import type { JSX } from "react"

import type { SelectedOrgId } from "../../features/organization/organization-types"
import { SelectFilter } from "../ui-widgets/filter/select-filter"

import "./all-users-select-org-view.css"

interface Props {
    selectedOrgId: SelectedOrgId | null
    organizationOptions: { label: string; value: SelectedOrgId }[]
    onOrganizationSelected: (orgId: SelectedOrgId | null) => void
}

export const AllUsersSelectOrgView = observer(
    ({ selectedOrgId, organizationOptions, onOrganizationSelected }: Props): JSX.Element => {
        return (
            <div className="w-content all-users-select-org-view">
                <div className="card rounded-legacy-md p-6 shadow-legacy">
                    <h5 className="text-wultra-primary mb-legacy">Select an Organization</h5>
                    <p className="text-legacy-muted mb-legacy">
                        To continue, please select an organization from the list below.
                    </p>
                    <SelectFilter<SelectedOrgId>
                        options={organizationOptions}
                        value={selectedOrgId}
                        onChange={onOrganizationSelected}
                        noSelectionLabel="Select organization..."
                    />
                </div>
            </div>
        )
    }
)
